export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_originalFileName') || '原始文件名称',
    field: 'originalFileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_processFlag') || '文件处理状态',
    field: 'processFlag',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'processFlag' },
  },
  {
    title: that.$l('table_label_processMessage') || '文件处理结果',
    field: 'processMessage',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_processDatetime') || '文件处理时间',
    field: 'processDatetime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createByName') || '上传人',
    field: 'createByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createByTime') || '上传时间',
    field: 'createByTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
]
